import { qs, qsa } from "@fluorescent/dom";

import { section } from "@/glow";
import ProductTile from "@/lib/product-tile";
import navigationDots from "@/lib/navigation-dots";

const config = {
  dynamic: ".js-product-recommendations",
  bp: 608,
  slider: "[data-slider]",
  productTile: "[data-product-tile]",
};

section("product-recommendations", {
  dotNavigation: null,
  onLoad() {
    const { sectionId } = this.container.dataset;
    let recommendationsSection = qs(config.dynamic, this.container);
    if (recommendationsSection === null) {
      return;
    }
    this.slider;
    this.productTiles = [];

    const { productId: id, limit } = recommendationsSection.dataset;
    const requestUrl = `${theme.routes.productRecommendations}?section_id=${sectionId}&limit=${limit}&product_id=${id}`;

    const request = new XMLHttpRequest();
    request.open("GET", requestUrl, true);
    request.onload = () => {
      if (request.status >= 200 && request.status < 300) {
        let container = document.createElement("div");
        container.innerHTML = request.response;
        recommendationsSection.innerHTML = container.querySelector(
          config.dynamic
        ).innerHTML;

        const sliderContainer = qs(config.slider, recommendationsSection);
        const productTiles = qsa(config.productTile, recommendationsSection);

        if (sliderContainer) {
          import(flu.chunks.flickity).then(({ Flickity }) => {
            this.slider = new Flickity(sliderContainer, {
              adaptiveHeight: true,
              pageDots: false,
              prevNextButtons: false,
              watchCSS: true,
              wrapAround: false,
            });

            productTiles.forEach(tile => {
              this.productTiles.push(ProductTile(tile));
            });

            if (productTiles.length > 1) {
              this.dotNavigation = navigationDots(this.container, this.slider);

              this.slider.on("select", () => {
                this.dotNavigation.update(this.slider.selectedIndex);
              });
            }
          });
        }
      }
    };
    request.send();
  },

  onUnload() {
    this.slider && this.slider.destroy();
    this.productTiles.forEach(tile => tile.unload());
  },
});
